import {createSlice} from "@reduxjs/toolkit";
import {getAllClubs} from "./action";

const initialState = {
  state: {
    items: []
  },
  loading: true,
  error: ''
} as BaseState<ClubsState>

const slice = createSlice({
  name: 'clubSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllClubs.pending, (state) => ({
          ...state,
          loading: true
        })
    )
    builder.addCase(getAllClubs.fulfilled, (state, action) => {
        const { items, meta, summary } = action.payload
        return {
          state: {
            items,
            meta,
            summary,
          },
          loading: false,
          error: null
        }
      }
    )
    builder.addCase(getAllClubs.rejected, () => ({
          state: {
            items: [],
            meta: null,
            summary: null,
          },
          loading: false,
          error: 'Failed to get clubs, please try again'
        })
    )
    
  }
})

export default slice